<template>
    <div class="HomeCardContent py-3">
        <div v-if="loaded">
            <div class="mb-3 container px-0 d-flex flex-row justify-content-between align-items-center">
                <div class="d-flex flex-row align-items-center justify-content-between mb-2 w-100">
                    <h3 class="home-title mb-0 mr-5">{{ title }}</h3>
                </div>
            </div>
            <div class="container px-0" v-if="cardType === 'corporateEvent'">
                <div v-if="locationsLoading">
                    <b-spinner></b-spinner>
                </div>
                <b-form-select v-else v-model="selectedEventLocation" class="select-location mt-4 mb-5 confirm-input">
                    <option v-for="location in eventLocations" :value="location.value">{{ location.label }}</option>
                </b-form-select>
            </div>
            <div class="position-relative">
                <div class="pb-5 content-container px-0 mx-auto" v-if="loaded">
                    <div class="card-container " :key="i" v-for="(item, i) in content">

                        <ArticleCard class="h-100" :item="item" :type="type" v-if="cardType === 'article'"
                            :swiping="swiping">
                        </ArticleCard>
                        <EventCard class="h-100" :item="item" :type="type" v-else-if="cardType === 'corporateEvent'"
                            :swiping="swiping">
                        </EventCard>
                        <VideoCard class="h-100" :video="item" :type="type" v-else-if="item.media === 'video'"
                            :swiping="swiping" />
                    </div>
                    <div v-if="content.length === 0 && cardType === 'corporateEvent'">
                        <h3>No events found at the selected location, please select a different location or choose "Show
                            all" to see
                            all available events</h3>
                    </div>
                </div>
                <div v-else class="py-5 container d-flex flex-row justify-content-center">
                    <b-spinner class="brand-primary"></b-spinner>
                </div>
            </div>
        </div>
        <div v-else class="mb-3 container d-flex flex-row justify-content-between align-items-center">
            <HomeLoading />
        </div>
        <div id="pageNumber" class="mx-auto content-container d-flex flex-column align-items-end pb-5" v-if="loaded && pagination">
            <div class="d-block p-text">
                Page <b>{{ pagination.current_page }}</b> of <b>{{ pagination.total_pages }}</b>
            </div>
            <div class="row" v-if="pagination.total_pages > 1">
                <b-button class="mr-4" :disabled="!pagination.has_prev_page" variant="cta-outline" squared
                    @click="getContent(pagination.current_page - 1)">Previous</b-button>
                <b-button :disabled="!pagination.has_next_page" variant="cta-outline" squared
                    @click="getContent(pagination.current_page + 1)">Next</b-button>
            </div>

        </div>
    </div>
</template>

<script>
import axios from "axios"
import slick from "vue-slick"
import VideoCard from "@/components/Home/New/VideoCard.vue"
import EventCard from "@/components/Home/New/EventCard.vue"
import BookingCard from "@/components/Home/New/BookingCard.vue"
import PodcastCard from "@/components/Home/New/PodcastCard.vue"
import HomeBannerEventCard from "@/components/Home/New/HomeBannerEventCard.vue";
import EventBus from "@/helpers/eventbus";
import HomeRecipeCard from "@/components/Home/New/HomeRecipeCard.vue";
import Loader from "@/components/Loader.vue";
import VimeoCard from "@/components/Home/New/VimeoCard.vue";
import CourseCard from "@/components/Home/New/CourseCard.vue";
import HomeLoading from "@/components/Home/New/HomeLoading.vue";
import HomeClinicCard from "@/components/Home/New/HomeClinicCard.vue";
import config from "@/config/constants";
import ArticleCard from "@/components/Home/New/ArticleCard.vue"
import ArticleCardThumbnail from "./ArticleCardThumbnail.vue"
import EventCardThumbnail from "./EventCardThumbnail.vue"

export default {
    name: "HomeCardCarousel",
    props: {
        title: String,
        type: String,
        cardType: String,
        permaTag: String,
        additionalTag: String,
        upcoming: {
            type: Boolean,
            default: false
        },
        promoText: {
            type: String,
            default: null
        },
        mute: {
            type: Boolean,
            default: false
        },
        exerciseTags: {
          type: Array,
          default() {
            return []
          },
        },
      preventScroll: {
        type: Boolean,
        default: false
      }
    },
    components: {
        HomeLoading,
        HomeClinicCard,
        HomeRecipeCard,
        VideoCard,
        EventCard,
        BookingCard,
        PodcastCard,
        HomeBannerEventCard,
        slick,
        Loader,
        VimeoCard,
        CourseCard,
        ArticleCard,
        ArticleCardThumbnail,
        EventCardThumbnail,
    },
    data() {
        return {
            pagination: {
                has_prev_page: false,
                has_next_page: false,
            },
            eventLocations: [{ label: 'Show all', value: 'all' }],
            selectedEventLocation: 'all',
            locationsLoading: true,
            reminders: [],
            swiping: false,
            loaded: false,
            loading_new_content: false,
            content: [],
            events: [],
            page: 1,
            totalRecords: 0,
            totalPages: 0,
            optionalTag: [],
            showArrows: false,
            clinicSettings: null,
            searchTerm: '',
            slickOptions: {
                initialSlide: 0,
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 3,
                nextArrow:
                    '<div class="slick-arrow-next std-arrow">' +
                    '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-right text-white fa-4xs"></i></a>' +
                    '</div>',
                prevArrow:
                    '<div class="slick-arrow-prev std-arrow">' +
                    '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-left text-white fa-4xs"></i></a>' +
                    '</div>',
                adaptiveHeight: true,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 951,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 1066,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1315,
                        settings: {
                            slidesToShow: 4
                        }
                    }
                ],
            },
            eventSlickOptions: {
                initialSlide: 0,
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                nextArrow:
                    '<div class="slick-arrow-next">' +
                    '<a class="bg-brand-highlight-1 slick-arrow-container"><i class="fas fa-chevron-right text-white fa-4xs"></i></a>' +
                    '</div>',
                prevArrow:
                    '<div class="slick-arrow-prev">' +
                    '<a class="bg-brand-highlight-1 slick-arrow-container"><i class="fas fa-chevron-left text-white fa-4xs"></i></a>' +
                    '</div>',
                adaptiveHeight: true,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    }
                ],
            },
        };
    },
    methods: {
        async getLocations() {
            let self = this;
            const payload = {
                user_id: this.$store.getters.user_id
            };
            let res = await axios.post(
                config.api_env + "/application/api-hc/get-locations",
                payload,
                config.options
            );
            if (res.data.success) {

                res.data.locations.forEach((location) => {
                    self.eventLocations.unshift({ label: location.location_label, value: location.location_id })
                })
                this.locationsLoading = false;
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        },
        isVimeoVideo(video, type) {
            if (type === 'studio' || type === 'gym') return true;
            return (video.url && video.url.includes('vimeo')) || (video.embed_video && video.embed_video.includes('vimeo'));
        },
        seeMore() {
            let type = this.type
            this.$router.push("/content/" + type + '/');
        },
        handleBeforeChange() {
            //prevents reroute whilst tiles are in motion
            this.swiping = true;
            setTimeout(() => { this.swiping = false }, 1000)
        },
        async getContent(page = 1) {
            if(!this.preventScroll) this.scrollToRef();
            this.loading = true;
            let contentPath = '';
            let contentType;
            switch (this.type) {
                case 'corporateEvent':
                    contentPath = "/application/api/u/sapphire/home/content";
                    contentType = 'events'
                    break;
                case 'standaloneArticles':
                    contentPath = "/application/api/u/sapphire/home/content";
                    contentType = 'articles'
                    break;
                case 'exercise':
                  contentPath = "/application/api/u/sapphire/home/content";
                  contentType = 'articles'
                  break;
                case 'featured-event':
                    contentPath = "/application/api/u/studio/events/trending";
                    contentType = 'events'
                    break;
                case 'recipes':
                    contentPath = "/application/api/u/content/nutrition";
                    contentType = 'articles'

                    break;
                case 'clinic':
                    contentPath = "/application/api/u/home/get-dc-banner";
                    contentType = 'courses'
                    break;
                default:
                    contentPath = "/application/api/u/sapphire/home/content";
                    contentType = 'events'

            }
            let tags = [];
            if (this.optionalTag.length > 0) {
                tags.unshift(this.optionalTag[0])
            }
            if (this.additionalTag) {
                tags.unshift(this.additionalTag);
            }
            if(this.type == 'exercise' && !this.optionalTag.length)
            {
              tags.push(...this.exerciseTags)
            }

            const payload = {
                user_id: this.$store.getters.user_id,
                tags: tags,
                search_term: this.searchTerm,
                type: contentType,
                page: page,
                pageSize: 30,
            };
            if (this.permaTag) {
                payload.tags.push(this.permaTag)
            }
            if (this.upcoming) {
                payload.upcoming = true;
            }

            if (this.cardType === 'corporateEvent') {
                payload.filter = this.selectedEventLocation;
            }
            let res = await this.axios.post(
                process.env.VUE_APP_API_PATH +
                contentPath,
                payload, config.options
            );

            if (res.data.success) {
                this.loaded = true;
                this.content = res.data?.data;
                this.pagination = res.data?.meta?.pagination;
                this.totalRecords = res.data?.meta?.pagination?.total;
                this.totalPages = res.data?.meta?.pagination?.total_pages
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login");
            } else {
                console.log('no data')
                this.loading_new_content = false;
                this.loaded = true;
            }

        },
        reinitSlider(backToStart = false) {
            let self = this;
            if (backToStart) this.slickOptions.initialSlide = 0;
            if (self.$refs.slick) {
                let currentSlide = backToStart ? 0 : self.$refs.slick.currentSlide();
                this.$refs.slick.destroy();
                this.$nextTick(() => {
                    let options = this.type === 'featured-event' ? self.eventSlickOptions : self.slickOptions;
                    options.initialSlide = currentSlide;
                    self.$refs.slick.create(options);
                });
            }
            this.loading_new_content = false;
        },

    },
    mounted() {
        let self = this;
        if (this.cardType === 'corporateEvent') {
            this.getLocations();
        }
        EventBus.$on("setTag", function (tag) {
            if (tag) {
                self.optionalTag = [tag];
            } else {
                self.optionalTag = [];
            }
        });
        EventBus.$on("setSearch", function (search) {
            self.searchTerm = search
        });
        this.getContent(true);
        EventBus.$on('setBookingReminders', (data) => {
            this.reminders = data;
        })
        EventBus.$on('locationChange', () => {
            self.loaded = false;
            if (self.$refs.slick) {
                self.$refs.slick.goTo(0);
            }
            self.page = 1;
            self.getContent(true, true);
        })
    },
    watch: {
        optionalTag() {
            if (this.type !== 'featured-event') {
                this.loaded = false;
                if (this.$refs.slick) {
                    this.$refs.slick.goTo(0);
                }
                this.page = 1;
                this.getContent(true, true);
            }
        },
        searchTerm() {
            if (this.type !== 'featured-event') {
                this.loaded = false;
                if (this.$refs.slick) {
                    this.$refs.slick.goTo(0);
                }
                this.page = 1;
                this.getContent(true, true);
            }
        },
        selectedEventLocation() {
            if (this.type !== 'featured-event') {
                this.loaded = false;
                if (this.$refs.slick) {
                    this.$refs.slick.goTo(0);
                }
                this.page = 1;
                this.getContent(true, true);
            }
        },
    },
};
</script>

<style lang="less">
.HomeCardContent {
    .content-container {
        display: grid;
        column-gap: 20px;
        row-gap: 20px;
        grid-template-columns: 1fr 1fr 1fr;
    }

    @media only screen and (max-width: 1068px) {
        .content-container {
            grid-template-columns: 1fr 1fr !important;
        }
    }

    @media only screen and (max-width: 768px) {
        .content-container {
            grid-template-columns: 1fr !important;
        }
    }

    .confirm-input {
        font-family: "DMSans";
        font-size: 1.8rem;
        padding: 12.5px;
        height: 50px;
        border: 1px solid #d3d3d3;
        border-radius: 8px;
        width: 300px;
        max-width: 100%;
    }

    .slick-track {
        display: flex !important;
    }

    .slick-slide {
        height: inherit !important;
    }

    .slick-slide>div:first-child {
        height: 100% !important;
    }



    .slick-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-30%);
        z-index: 10;
        background-color: transparent;
        border: none;
        font-size: 1rem;

        &:focus {
            outline: none;
        }
    }

    &.hide-arrows {
        .std-arrow {
            display: none !important;
        }
    }

    .home-title {
        font-size: 2rem;
    }

    .home-title-line {
        height: 1px;
        width: 200px;
        max-width: 50%;
    }

    .promoText {
        font-family: DMSans, Arial, Helvetica, sans-serif;
        font-size: 1.75rem;
    }

    .hideLoader {
        width: 0px !important;
    }

    .slick-slide:has(.hideLoader) {
        width: 0px !important;
    }

    .see-more-link {
        font-size: 1.5em;

        &:hover {
            cursor: pointer;
        }
    }

    .slick-slider {
        .slick-slide {
            transform: scale(1);
            margin: 0 8px;
        }
    }

    .slick-list {
        margin: 0 -15px;
        overflow: visible;
    }

    .slick-arrow-container {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        line-height: 0;
        padding: 10px;
        height: 100%;
        display: none;
    }

    @media only screen and (max-width: 767px) {
        .home-title-line {
            display: none !important;
        }
    }

    @media only screen and (min-width: 980px) and (max-width: 992px) {
        .slick-arrow-container {
            display: flex;
        }
    }

    @media only screen and (min-width: 1130px) and (max-width: 1200px) {
        .slick-arrow-container {
            display: flex;
        }
    }

    @media only screen and (min-width: 1320px) {
        .slick-arrow-container {
            display: flex;
        }
    }

    .displayLoader {}

    .slick-arrow-next {
        right: -45px;
    }

    .slick-arrow-prev {
        left: -75px;
    }

    .std-arrow {
        top: 40% !important;

        &.slick-arrow-next {
            right: 0px;
        }

        &.slick-disabled {
            display: none !important;
        }

        &.slick-arrow-prev {
            left: -25px;
        }

        .std-arrow-container {
            background-color: rgba(225, 225, 225, 0.7);
        }
    }

    .slick-track {
        margin-left: 0;
    }

    .slick-slide.slick-active {
        pointer-events: auto;
        opacity: 1;
    }

    .slick-slide {
        pointer-events: none;
    }

    .slick-disabled {
        .bg-brand-highlight-1 {
            background-color: #eee;
            cursor: default;
        }
    }

    .video-blur-container {
        pointer-events: none;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;

        .container {
            flex-grow: 1;

        }

        .left-blur {
            flex-grow: 1;
            background: rgb(247, 247, 247);
            background: linear-gradient(270deg, rgba(250, 250, 250, 0.0) 5%, rgba(250, 250, 250, 0.7) 15%, rgba(250, 250, 250, 1) 45%);
        }

        .right-blur {
            flex-grow: 1;
            background: rgb(247, 247, 247);
            background: linear-gradient(90deg, rgba(250, 250, 250, 0.0) 5%, rgba(250, 250, 250, 0.7) 15%, rgba(250, 250, 250, 1) 45%);
        }
    }
}
</style>